import React, { useCallback } from 'react';

const brandColor = '#3894A8';
const brandColorDark = '#2D7A8A';
const iconSize = 20;
const iconStyle = { width: iconSize, height: iconSize, opacity: 0.85, display: 'block' };

function SocialIconInstagram() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyle} aria-hidden>
      <path fill="currentColor" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );
}
function SocialIconFacebook() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyle} aria-hidden>
      <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
}
function SocialIconTikTok() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyle} aria-hidden>
      <path fill="currentColor" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  );
}
function SocialIconWhatsApp() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyle} aria-hidden>
      <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}

async function dataUrlToFile(dataUrl, filename) {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  const type = blob.type || 'image/jpeg';
  const ext = type.includes('png') ? 'png' : 'jpg';
  const safeName = (filename || 'mojenaocale-screenshot').replace(/[^\w-]+/g, '-');
  return new File([blob], `${safeName}.${ext}`, { type });
}

export default function MediaPreviewModal({
  open,
  onClose,
  title = 'Pregled',
  dataUrl,
  videoUrl,
  primaryLabel = 'Podijeli',
  onPrimary,
  primaryDisabled,
  tertiaryLabel,
  onTertiary,
  tertiaryDisabled,
  secondaryLabel = 'Nastavi',
  onContinue,
  mobile = false,
}) {
  const onShare = useCallback(async () => {
    if (!dataUrl) return;
    try {
      const file = await dataUrlToFile(dataUrl, 'mojenaocale-screenshot');
      if (navigator?.share && navigator?.canShare?.({ files: [file] })) {
        try {
          await navigator.share({ files: [file] });
        } catch {
          await navigator.share({
            title: 'MojeNaocale.ba',
            text: 'Moj izgled sa naočalama',
            files: [file],
          });
        }
        return;
      }
    } catch {
      // ignore and fallback to download
    }

    try {
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = 'mojenaocale-screenshot.jpg';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch {
      // ignore
    }
  }, [dataUrl]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.82)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 100000,
        display: 'flex',
        alignItems: mobile ? 'stretch' : 'center',
        justifyContent: mobile ? 'stretch' : 'center',
        padding: mobile ? 0 : 18,
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        style={{
          width: mobile ? '100%' : 'min(980px, 100%)',
          maxWidth: mobile ? '100%' : undefined,
          maxHeight: mobile ? '100%' : '92vh',
          overflow: 'hidden',
          borderRadius: mobile ? 0 : 22,
          border: mobile ? 'none' : '1px solid rgba(255, 255, 255, 0.08)',
          background: 'linear-gradient(180deg, #16161e 0%, #0e0e14 100%)',
          boxShadow: mobile ? 'none' : '0 40px 100px rgba(0, 0, 0, 0.6)',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            padding: '18px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 700, color: '#f8fafc' }}>{title}</div>
          <button
            type="button"
            onClick={onClose}
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: 'rgba(255, 255, 255, 0.06)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              color: '#94a3b8',
              fontSize: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            aria-label="Zatvori"
          >
            ×
          </button>
        </div>

        <div style={{ padding: 16, overflow: 'auto' }}>
          <div
            style={{
              borderRadius: 18,
              overflow: 'hidden',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              background: '#000',
            }}
          >
            {videoUrl ? (
              <video
                src={videoUrl}
                controls
                playsInline
                autoPlay
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            ) : dataUrl ? (
              <img
                src={dataUrl}
                alt="preview"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            ) : (
              <div style={{ 
                padding: 48, 
                color: '#94a3b8', 
                fontSize: 14, 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                minHeight: 200,
                gap: 16,
              }}>
                <div style={{
                  width: 40,
                  height: 40,
                  border: '3px solid rgba(56, 148, 168, 0.2)',
                  borderTopColor: '#3894A8',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                <span>Generiranje videa...</span>
              </div>
            )}
          </div>

          {/* Share Actions: social icons, then full-width Podijeli, then Preuzmi */}
          <div style={{ marginTop: 14, width: '100%' }}>
            {/* Social icons */}
            <div style={{ display: 'flex', gap: 14, justifyContent: 'center', marginBottom: 12, color: '#94a3b8' }}>
              <SocialIconInstagram />
              <SocialIconFacebook />
              <SocialIconTikTok />
              <SocialIconWhatsApp />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
              <button
                type="button"
                onClick={() => (onPrimary ? onPrimary() : onShare())}
                disabled={!!primaryDisabled || (!onPrimary && !dataUrl && !videoUrl)}
                style={{
                  width: '100%',
                  padding: '12px 18px',
                  borderRadius: 10,
                  border: 'none',
                  background: !primaryDisabled
                    ? `linear-gradient(135deg, ${brandColor} 0%, ${brandColorDark} 100%)`
                    : 'rgba(255,255,255,0.06)',
                  color: !primaryDisabled ? '#fff' : '#64748b',
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: primaryDisabled ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  boxShadow: !primaryDisabled ? '0 4px 14px rgba(56, 148, 168, 0.35)' : 'none',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="18" cy="5" r="3"/>
                  <circle cx="6" cy="12" r="3"/>
                  <circle cx="18" cy="19" r="3"/>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                </svg>
                {primaryLabel}
              </button>
              {(dataUrl || videoUrl) && (
                dataUrl ? (
                  <a
                    href={dataUrl}
                    download="mojenaocale-screenshot.jpg"
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      padding: '12px 18px',
                      borderRadius: 10,
                      background: 'rgba(255, 255, 255, 0.08)',
                      color: '#e2e8f0',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      fontSize: 14,
                      fontWeight: 600,
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                    }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7 10 12 15 17 10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    Preuzmi
                  </a>
                ) : (
                  <a
                    href={videoUrl}
                    download="mojenaocale-video.mp4"
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      padding: '12px 18px',
                      borderRadius: 10,
                      background: 'rgba(255, 255, 255, 0.08)',
                      color: '#e2e8f0',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      fontSize: 14,
                      fontWeight: 600,
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                    }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7 10 12 15 17 10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    Preuzmi
                  </a>
                )
              )}
            </div>
            {/* Secondary Actions (tertiary + Nastavi) */}
            {(!!tertiaryLabel || !!onContinue) && (
              <div style={{ marginTop: 14, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {!!tertiaryLabel && (
                  <button
                    type="button"
                    onClick={() => onTertiary?.()}
                    disabled={!!tertiaryDisabled}
                    style={{
                      flex: 1,
                      minWidth: 180,
                      padding: '12px 14px',
                      borderRadius: 12,
                      border: '1px solid rgba(255,255,255,0.10)',
                      background: tertiaryDisabled ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.06)',
                      color: tertiaryDisabled ? '#64748b' : '#e2e8f0',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: tertiaryDisabled ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {tertiaryLabel}
                  </button>
                )}
                {onContinue && (
                  <button
                    type="button"
                    onClick={() => onContinue?.()}
                    style={{
                      flex: 1,
                      minWidth: 180,
                      padding: '12px 14px',
                      borderRadius: 12,
                      border: '1px solid rgba(255,255,255,0.10)',
                      background: 'rgba(255,255,255,0.06)',
                      color: '#e2e8f0',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    {secondaryLabel}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


